const OfferBlock = ({ props, slots }) => {
    const { className } = props;

    return (
        <div class={className}>
            {slots().default}
        </div>
    );
};

OfferBlock.props = {
    className: {
        type: String,
    },
};

export default OfferBlock;
